import { ParkingLot } from '../../models/ParkingLot.model'
import { ParkingLotDTO } from '../../models/ParkingLotDTO.model'

export class ParkingLotService {
  public static formatParkingLot(parkingLot: ParkingLotDTO): ParkingLot {
    return {
      id: parkingLot.id,
      name: parkingLot.name,
      gpsLat: parkingLot.gpsLat,
      gpsLong: parkingLot.gpsLong,
      updatedAt: new Date(parkingLot.updatedAt),
      createdAt: new Date(parkingLot.createdAt),
      trailSystemId: parkingLot.trailSystemId,
    }
  }
}
